
import { defineComponent } from "vue";
import { Doughnut } from "vue-chartjs";
import { Chart as ChartJS, Title, Tooltip, ArcElement } from "chart.js";

ChartJS.register(Title, Tooltip, ArcElement);

export default defineComponent({
  name: "TotalVolume",
  components: { Doughnut },
  data() {
    return {
      bases: ["Weekly", "Monthly", "Yearly"] as string[],
      chartOptions: {
        responsive: false,
        aspectRatio: 1,
        cutout: 82.5,
        plugins: {
          legend: {
            display: false,
          },
        },
      },
    };
  },
  props: {
    role: {
      type: String,
      required: true,
    },
    basis: {
      type: String,
      required: true,
    },
    totalSurplusVolume: {
      type: Number,
      required: true,
    },
    commonFoodType: {
      type: Object,
      required: true,
    },
    successRate: {
      type: Number,
      required: true,
    },
    chartData: {
      type: Object,
      required: true,
    },
  },
});
